import {API_DRIVER} from "../configs/axios";

export const ESimService = {
    fetchEsitoInvioEmail: (integrationId, tipoDiRichiesta, idLotto, nTelefono,
        seriale, indirizzoEmail, dataInvioFrom, dataInvioTo, esitoInvio, page, size, sort) => {
        const [sortBy, sortOrder] = sort.split(',');
        return API_DRIVER.get(`/api/v1/esim/monitoring/esito-invio-email`, {
            params: {
                integrationId,
                tipoDiRichiesta,
                idLotto,
                nTelefono,
                seriale,
                indirizzoEmail,
                dataInvioFrom,
                dataInvioTo,
                esitoInvio,
                page,
                size,
                sortBy,
                sortOrder
            }
        })
    },
    fetchEsitoInvioEmailFilterOptions: (integrationId) => {
        return API_DRIVER.get(`/api/monitoring-esim/esito-invio-email/${integrationId}/filter-data`)
    },
    fetchParametriESim: (integrationId, numeroDiTelefono, nSeriale, statoSim, emailInviata, page, size, sort) => {
        return API_DRIVER.get('/api/monitoring-esim/parametri-esim', {
            params: {
                integrationId,
                numeroDiTelefono,
                nSeriale,
                statoSim,
                emailInviata,
                page,
                size,
                sort,
            }
        })
    },
    fetchParametriESimFilterOptions: (integrationId) => {
        return API_DRIVER.get(`/api/monitoring-esim/parametri-esim/${integrationId}/filter-data`)
    },
    downloadEsitoInvioEmailCsv: (
        integrationId,
        page,
        size,
        sortBy,
        sortOrder,
        idLotto,
        nTelefono,
        imsi,
        indirizzoEmail,
        seriale,
        esitoInvio,
        tipoDiRichiesta,
        dataInvioFrom,
        dataInvioTo
    ) => {
        return API_DRIVER.get(`/api/v1/esim/monitoring/esito-invio-email/download-csv`, {
            responseType: 'blob',
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                idLotto,
                nTelefono,
                imsi,
                indirizzoEmail,
                seriale,
                esitoInvio,
                tipoDiRichiesta,
                dataInvioFrom,
                dataInvioTo
            }
        })
    },
    downloadParametriESimCsv: (
        integrationId, areAllSelected, selectedRows, numeroDiTelefono, nSeriale, statoSim, emailInviata, sort
    ) => {
        return API_DRIVER.get(`/api/monitoring-esim/parametri-esim/csv`, {
            responseType: 'blob',
            params: {
                integrationId,
                areAllSelected,
                selectedRows,
                numeroDiTelefono,
                nSeriale,
                statoSim,
                emailInviata,
                sort,
            }
        })
    },
    importDistribuzioneEsim: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/esim/csv-validations/digitalkits`, dtoBody, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    importDistribuzioneEsimSostitutive: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/esim/csv-validations/distributions`, dtoBody, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    distribuzioneEsim: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/esim/monitoring/esito-invio-email/digitalkits`, dtoBody)
    },
    distribuzioneDigitaleEsimSostitutive: (dtoBody) => {
        return API_DRIVER.post("/api/v1/esim/product-change/distributions", dtoBody);
    },
    exportEsim: (requestBody) => {
        return API_DRIVER.post(`/api/v1/esim/distributions/digitalkits/export-csv`, requestBody, {
            responseType: 'blob',
        })
    },
    fetchEsitoCambioFormato: (integrationId, page, size, sortBy, sortOrder, idLotto, numeroDiTelefono, numeroSeriale, esitoCambioFormato, dataInvioRichiestaFrom,
        dataInvioRichiestaTo,email ) => {
        return API_DRIVER.get('/api/v1/esim/monitoring/esito-cambio-formato', {
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                idLotto,
                numeroDiTelefono,
                numeroSeriale,
                esitoCambioFormato,
                dataInvioRichiestaFrom,
                dataInvioRichiestaTo,
                email
            }
        })
    },
    cambioFormatoDistribuzione: (dtoBody) => {
        return API_DRIVER.post('/api/v1/esim/product-change/distributions-replacements', dtoBody)
    },
    cambioFormato: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/esim/product-change/replacements`, dtoBody)
    },
    fetchSostitutiveList: (integrationId, simType) => {
        const params = {};
        if (simType) {
            params.simType = simType;
        }
        return API_DRIVER.get(`/api/v1/esim/${integrationId}/sostitutive`, { params });
    },
    exportSostituliveListCsv: (integrationId) => {
        return API_DRIVER.get(`/api/v1/esim/${integrationId}/sostitutive/download-csv`)
    },
    importCambioFormatoDistribuzioneCsv: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/esim/csv-validations/distributions-replacements`, dtoBody, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    exportCambioFormatoDistribuzioneCsv: (requestBody) => {
        return API_DRIVER.post(`/api/v1/esim/product-change/distributions-replacements/export-csv`, requestBody, {
            responseType: 'blob',
        })
    },
    importCambioFormattoCsv: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/esim/csv-validations/replacements`, dtoBody, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    exportCambioFormatoCsv: (requestBody) => {
        return API_DRIVER.post(`/api/v1/esim/product-change/replacements/export-csv`, requestBody, {
            responseType: 'blob',
        })
    },
    exportMassiveTagsCsv: (requestBody) => {
        return API_DRIVER.post(`/api/v1/tag-csv/export-csv`, requestBody, {
            responseType: 'blob',
        })
    },
    importMassiveTagsCsv: (dtoBody) => {
        return API_DRIVER.post(`/api/v1/tag-csv/import-csv`, dtoBody, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    batchAssociateTags:(dtoBody)=>{
        return API_DRIVER.post(`/api/v1/tag-csv/batch-associate-tags`, dtoBody)
    },
    downloadEsitoCambioFormatoCsv: (
        integrationId, page, size, sortBy, sortOrder, esitoCambioFormato, numeroDiTelefono, numeroSeriale, idLotto, email, dataInvioRichiestaFrom, dataInvioRichiestaTo
    ) => {
        return API_DRIVER.get(`/api/v1/esim/monitoring/esito-cambio-formato/download-csv`, {
            responseType: 'blob',
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                esitoCambioFormato,
                numeroDiTelefono,
                numeroSeriale,
                idLotto,
                email,
                dataInvioRichiestaFrom,
                dataInvioRichiestaTo
            }
        })
    },
}